// import { useState, useEffect } from "react"
// // import { useAddNewUserMutation } from "./usersApiSlice"
// import { useAddUserMutation } from './usersApiSlice'
// import { useNavigate } from "react-router-dom"
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faSave } from "@fortawesome/free-solid-svg-icons"
// import { ROLES } from "../../config/roles"
// import useTitle from "../../hooks/useTitle"

// const USER_REGEX = /^[A-z]{3,20}$/
// const DISPLAYNAME_REGEX = /^[A-Za-z\s]{3,20}$/;
// const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/

// const NewUserForm = () => {
//     useTitle('Mudah Tech: New User')

//     const [addNewUser, {
//         isLoading,
//         isSuccess,
//         isError,
//         error
//     }] = useAddUserMutation()

//     const navigate = useNavigate()

//     const [username, setUsername] = useState('')
//     const [displayname, setDisplayname] = useState('')
//     const [validUsername, setValidUsername] = useState(false)
//     const [validDisplayname, setValidDisplayname] = useState(false)
//     const [password, setPassword] = useState('')
//     const [validPassword, setValidPassword] = useState(false)
//     const [roles, setRoles] = useState(["Employee"])

//     useEffect(() => {
//         setValidUsername(USER_REGEX.test(username))
//     }, [username])

//     useEffect(() => {
//         setValidDisplayname(DISPLAYNAME_REGEX.test(displayname))
//     }, [displayname])

//     useEffect(() => {
//         setValidPassword(PWD_REGEX.test(password))
//     }, [password])

//     useEffect(() => {
//         if (isSuccess) {
//             setUsername('')
//             setPassword('')
//             setRoles([])
//             navigate('/dash/users')
//         }
//     }, [isSuccess, navigate])

//     const onUsernameChanged = e => setUsername(e.target.value)
//     const onDisplaynameChanged = e => setDisplayname(e.target.value)
//     const onPasswordChanged = e => setPassword(e.target.value)

//     const onRolesChanged = e => {
//         const values = Array.from(
//             e.target.selectedOptions, //HTMLCollection 
//             (option) => option.value
//         )
//         setRoles(values)
//     }

//     const canSave = [roles.length, validUsername, validDisplayname, validPassword].every(Boolean) && !isLoading

//     const onSaveUserClicked = async (e) => {
//         e.preventDefault()
//         if (canSave) {
//             await addNewUser({ username, displayname, password, roles })
//         }
//     }

//     const options = Object.values(ROLES).map(role => {
//         return (
//             <option
//                 key={role}
//                 value={role}

//             > {role}</option >
//         )
//     })

//     const errClass = isError ? "errmsg" : "offscreen"
//     const validUserClass = !validUsername ? 'form__input--incomplete' : ''
//     const validPwdClass = !validPassword ? 'form__input--incomplete' : ''
//     const validRolesClass = !Boolean(roles.length) ? 'form__input--incomplete' : ''


//     const content = (
//         <>
//             <p className="bg-red">{error?.data?.message}</p>

//             <form className="form" onSubmit={onSaveUserClicked}>
//                 <div className="border border-gray-400 bg-gray-200 border-4 flex flex-cols rounded-md justify-between p-2">
//                     <h2 className="font-bold text-2xl text-gray-600">New User</h2>
//                     <div className="form__action-buttons">
//                         <button
//                             className="bg-blue-400 p-2 rounded-md text-blue-800 font-bold"
//                             title="Save"
//                             disabled={!canSave}
//                         >
//                             <FontAwesomeIcon icon={faSave} /> Save
//                         </button>
//                     </div>
//                 </div>

//                 {/* <div className="form__title-row">
//                     <div className="form__action-buttons">
//                         <button
//                             className="icon-button"
//                             title="Save"
//                             disabled={!canSave}
//                         >
//                             <FontAwesomeIcon icon={faSave} />
//                         </button>
//                     </div>
//                 </div> */}

//                 <table>
//                     <tbody>
//                         <tr>
//                             <td>
//                                 Username:
//                                 <label className="form__label" htmlFor="username"><span className="nowrap">[3-20 letters]</span></label>
//                             </td>
//                             <td>
//                                 <input
//                                     className={`form__input ${validUserClass}`}
//                                     id="username"
//                                     name="username"
//                                     type="text"
//                                     autoComplete="off"
//                                     value={username}
//                                     onChange={onUsernameChanged}
//                                 />
//                             </td>
//                         </tr>
//                         <tr>
//                             <td>
//                                 <label className="form__label" htmlFor="username">Display Name: <span className="nowrap">[3-20 letters]</span></label>
//                             </td>
//                             <td>
//                                 <input
//                                     className={`form__input ${validUserClass}`}
//                                     id="displayname"
//                                     name="displayname"
//                                     placeholder="display name"
//                                     type="text"
//                                     autoComplete="off"
//                                     value={displayname}
//                                     onChange={onDisplaynameChanged}
//                                 />
//                             </td>
//                         </tr>
//                         <tr>
//                             <td>
//                                 <label className="form__label" htmlFor="password">
//                                     Password: <span className="nowrap">[4-12 chars incl. !@#$%]</span></label>
//                             </td>
//                             <td>
//                                 <input
//                                     className={`form__input ${validPwdClass}`}
//                                     id="password"
//                                     name="password"
//                                     type="password"
//                                     value={password}
//                                     onChange={onPasswordChanged}
//                                 />
//                             </td>
//                         </tr>
//                     </tbody>
//                 </table>        

//                 <div className="flex mt-10">
//                     <div>
//                         <label className="form__label" htmlFor="roles">ASSIGNED ROLES:</label>
//                     </div>
//                     <select
//                         id="roles"
//                         name="roles"
//                         className="ml-10"
//                         multiple={true}
//                         size="3"
//                         value={roles}
//                         onChange={onRolesChanged}
//                     >
//                         {options}
//                     </select>                    
//                 </div>



                







//             </form>
//         </>
//     )

//     return content
// }
// export default NewUserForm

import { useState, useEffect } from "react";
import { useAddUserMutation } from "./usersApiSlice";
import { useNavigate } from "react-router-dom";
import { ROLES } from "../../config/roles";
import useTitle from "../../hooks/useTitle";

const USER_REGEX = /^[A-z]{3,20}$/;
const DISPLAYNAME_REGEX = /^[A-Za-z\s]{3,20}$/;
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/;

export default function NewUserForm() {
  useTitle("Mudah Tech: New User");

  const [addNewUser, { isLoading, isSuccess, isError, error }] = useAddUserMutation();
  const navigate = useNavigate();

  // form state
  const [username, setUsername] = useState("");
  const [displayname, setDisplayname] = useState("");
  const [password, setPassword] = useState("");
  const [roles, setRoles] = useState(["Employee"]);

  // validation flags
  const [validUsername, setValidUsername] = useState(false);
  const [validDisplayname, setValidDisplayname] = useState(false);
  const [validPassword, setValidPassword] = useState(false);

  // validate on change
  useEffect(() => setValidUsername(USER_REGEX.test(username)), [username]);
  useEffect(() => setValidDisplayname(DISPLAYNAME_REGEX.test(displayname)), [displayname]);
  useEffect(() => setValidPassword(PWD_REGEX.test(password)), [password]);

  // go back after success
  useEffect(() => {
    if (isSuccess) {
      navigate("/dash/users");
    }
  }, [isSuccess, navigate]);

  const onRolesChanged = (e) => {
    const values = Array.from(e.target.selectedOptions, (o) => o.value);
    setRoles(values);
  };

  const canSave =
    [roles.length, validUsername, validDisplayname, validPassword].every(Boolean) && !isLoading;

  const onSaveUserClicked = async (e) => {
    e.preventDefault();
    if (!canSave) return;
    try {
      await addNewUser({ username, displayname, password, roles }).unwrap();
    } catch (err) {
      // handled by error banner
    }
  };

  const errText = error?.data?.message ?? "";

  return (
    <div className="min-h-full px-4 sm:px-6 lg:px-8 py-6">
      {/* Header */}
      {/* <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">New User</h1>
          <p className="text-sm text-gray-500">Create a new account with roles and status.</p>
        </div>
        <button
          onClick={onSaveUserClicked}
          disabled={!canSave}
          className={`rounded-xl px-4 py-2 text-sm text-white ${
            canSave ? "bg-gray-900 hover:bg-black" : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          Save
        </button>
      </div> */}

      {/* Error banner */}
      {isError && (
        <div className="mt-4 rounded-xl border border-rose-200 bg-rose-50 p-3 text-rose-700">
          {errText || "Something went wrong."}
        </div>
      )}

      {/* Card form */}
      <form onSubmit={onSaveUserClicked} className="mt-6">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Username */}
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                Username <span className="text-gray-400 font-normal">[3–20 letters]</span>
              </label>
              <input
                id="username"
                type="text"
                autoComplete="off"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className={`mt-1 w-full rounded-xl border ${
                  validUsername ? "border-gray-200" : "border-amber-300"
                } bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-black/5`}
                placeholder="johndoe"
              />
              {!validUsername && username && (
                <p className="mt-1 text-xs text-amber-600">Letters only, 3–20 characters.</p>
              )}
            </div>

            {/* Display name */}
            <div>
              <label htmlFor="displayname" className="block text-sm font-medium text-gray-700">
                Display Name <span className="text-gray-400 font-normal">[3–20 letters]</span>
              </label>
              <input
                id="displayname"
                type="text"
                autoComplete="off"
                value={displayname}
                onChange={(e) => setDisplayname(e.target.value)}
                className={`mt-1 w-full rounded-xl border ${
                  validDisplayname ? "border-gray-200" : "border-amber-300"
                } bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-black/5`}
                placeholder="John Doe"
              />
              {!validDisplayname && displayname && (
                <p className="mt-1 text-xs text-amber-600">Letters/spaces, 3–20 characters.</p>
              )}
            </div>

            {/* Password */}
            <div className="md:col-span-2">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password{" "}
                <span className="text-gray-400 font-normal">[4–12 chars incl. !@#$%]</span>
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`mt-1 w-full rounded-xl border ${
                  password && !validPassword ? "border-amber-300" : "border-gray-200"
                } bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-black/5`}
                placeholder="••••••••"
              />
              {password && !validPassword && (
                <p className="mt-1 text-xs text-amber-600">
                  4–12 chars; letters, numbers, or !@#$%.
                </p>
              )}
            </div>

            {/* Roles */}
            <div className="md:col-span-2">
              <label htmlFor="roles" className="block text-sm font-medium text-gray-700">
                Assigned Roles
              </label>
              <select
                id="roles"
                multiple
                size="3"
                value={roles}
                onChange={onRolesChanged}
                className={`mt-1 w-full rounded-xl border ${
                  roles?.length ? "border-gray-200" : "border-amber-300"
                } bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-black/5`}
              >
                {Object.values(ROLES).map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
              {!roles?.length && (
                <p className="mt-1 text-xs text-amber-600">Select at least one role.</p>
              )}
            </div>
          </div>

          {/* Footer actions */}
          <div className="mt-6 flex items-center justify-end">
            <button
              type="submit"
              disabled={!canSave}
              className={`rounded-xl px-4 py-2 text-sm text-white ${
                canSave ? "bg-gray-900 hover:bg-black" : "bg-gray-400 cursor-not-allowed"
              }`}
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
